import cssGlobal from './utils/cssGlobal';
import constants from './constants/styles';

export default cssGlobal({
  html: {
    height: '100%'
  },
  body: {
    margin: 0,
    padding: 0,
    fontFamily: constants.BASE_FONT_FAMILY,
    fontSize: constants.BASE_FONT_SIZE,
    height: '100%',
    minHeight: '100%'
  },
  '#root': {
    height: '100%'
  }
});



// WEBPACK FOOTER //
// ./src/index.styles.js